export { default } from './BlocComodiSeccio';
